import {Directive, ElementRef, HostListener, Input, Renderer2} from '@angular/core';

declare var dataLayer: any[];

@Directive({
  standalone: true,
  selector: '[gtmEventName], [gtmEventName][gtmEventData]'
})
export class GtmEventDirective {
  @Input() gtmEventName!: string;
  @Input() gtmEventData!: any;

  constructor(private el: ElementRef, private renderer: Renderer2) {
  }

  @HostListener('click', ['$event'])
  onClick(event: Event) {
    if (this.gtmEventName) {
      if (this.gtmEventData) {
        dataLayer.push({
          event: this.gtmEventName,
          ...this.gtmEventData
        });
      } else {
        dataLayer.push({
          event: this.gtmEventName
        });
      }
    }
  }
}
